/* Connect UsersLocal to the Backend */
import { connect } from 'react-redux';
import Userslocal from './Userslocal';
import * as userslocalactions from './Actions';
import CAC from './Constants';



const mapStateToProps = state => ({
    userlist: state.userlist,
    currentsenduser: state.currentsenduser,
    tickle: state.tickle,
    sendlist: state.sendlist,
});

const mapDispatchToProps = dispatch => ({
    pwGetUserlist: () => {
       dispatch(userslocalactions.pwGetUserlist()).then((response) => {
        !response.error ? 
        dispatch(userslocalactions.pwGetUserlistSuccess(response.value.data)) :
        dispatch(userslocalactions.pwGetUserlistFailure(response.value.data))
       });
    },
    pwGetSendlist: () => {
        dispatch(userslocalactions.pwGetSendlist()).then((response) => {
         !response.error ? 
         dispatch(userslocalactions.pwGetSendlistSuccess(response.value.data)) :
         dispatch(userslocalactions.pwGetSendlistFailure(response.value.data))
        });
     },   
    pwSetCurrentSendUser: (nextSendUser) => {
        dispatch({
        type: `${CAC.CURRENTSENDUSER}`,
        payload: nextSendUser
      });
        dispatch(userslocalactions.pwGetSends(nextSendUser)).then((response) => {
         !response.error ? 
         dispatch(userslocalactions.pwGetSendsSuccess(response.value.data)) :
         dispatch(userslocalactions.pwGetSendsFailure(response.value.data))
        });
        dispatch(userslocalactions.pwGetSendlist()).then((response) => {
            !response.error ? 
            dispatch(userslocalactions.pwGetSendlistSuccess(response.value.data)) :
            dispatch(userslocalactions.pwGetSendlistFailure(response.value.data))
        });
        dispatch(userslocalactions.pwGetSendlist()).then((response) => {
            !response.error ? 
            dispatch(userslocalactions.pwGetSendlistSuccess(response.value.data)) :
            dispatch(userslocalactions.pwGetSendlistFailure(response.value.data))
        }); 
     }
});

const UserslocalConnectContainer =  connect(mapStateToProps, mapDispatchToProps)(Userslocal);

export default UserslocalConnectContainer;


// WEBPACK FOOTER //
// ./src/UserslocalConnectContainer.js